import React, { Component } from "react";
import Picker from "react-datepicker";
import { uk } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

// react-datepicker v8 formats the incoming date with no validity guard, so an
// Invalid Date (e.g. from `new Date(undefined)` when a field is missing) makes
// date-fns throw `RangeError: Invalid time value` during render — a crash the older
// v3 tolerated. Coerce any invalid/unparseable date prop to null before it reaches
// the picker. Every date picker in the app routes through this wrapper, so this one
// guard covers all call sites.
const toValidDate = value => {
  if (value == null) return null;
  const date = value instanceof Date ? value : new Date(value);
  return isNaN(date.getTime()) ? null : date;
};

const DATE_PROPS = ["startDate", "endDate", "minDate", "maxDate", "openToDate"];

export const DatePicker = ({ selected, onChange, className, ...rest }) => {
  const sanitized = { ...rest };
  DATE_PROPS.forEach(key => {
    if (key in sanitized) sanitized[key] = toValidDate(sanitized[key]);
  });

  return (
    <Picker
      locale={uk}
      dateFormat="dd/MM/yyyy"
      selected={toValidDate(selected)}
      className={className}
      onChange={onChange}
      {...sanitized}
    />
  );
};
